import React from "react";
// import { useExtractCatalogueController } from "../ExtractCatalogueTab/controller";
import {
    ExtractSetupStep,
    ExtractingStep,
    ExtractReviewTopSection,
    ExtractZipStep,
    ExtractSavingStep,
    ExtractCompleteStep,
} from "../ExtractCataloguetab/TopSection";
import { HiddenFileInputs } from "../ExtractCataloguetab/ReusableComponents";
import ExtractCatalogueTable from "../ExtractCataloguetab/ExtractTable";
import { useExtractCatalogueController } from "../ExtractCataloguetab/controller";
// import { ExtractSetupStep } from "../ExtractCataloguetab/TopSection";
// import ExtractCatalogueTable from "./ExtractCatalogueTab/ExtractTable";
// import { HiddenFileInputs } from "./ExtractCatalogueTab/ReusableComponents";

export default function ExtractCatalogueTab({ userID, onUploaded }) {
    const controller = useExtractCatalogueController({ userID, onUploaded });

    const { workflowStep } = controller;

    return (
        <div className="border bg-white">
            <HiddenFileInputs controller={controller} />

            {workflowStep === "setup" && (
                <ExtractSetupStep controller={controller} />
            )}

            {workflowStep === "extracting" && (
                <ExtractingStep controller={controller} />
            )}

            {workflowStep === "review" && (
                <>
                    <ExtractReviewTopSection controller={controller} />
                    <ExtractCatalogueTable controller={controller} />
                </>
            )}

            {workflowStep === "zip" && (
                <ExtractZipStep controller={controller} />
            )}

            {workflowStep === "saving" && (
                <ExtractSavingStep controller={controller} />
            )}

            {workflowStep === "complete" && (
                <ExtractCompleteStep controller={controller} />
            )}
        </div>
    );
}